import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {TdoChatDataModel} from '../../main-interface/office-communication/models/tdo-chat-data.model';
import {TdoChatConversationDataModel} from '../../main-interface/office-communication/models/tdo-chat-conversation-data.model';
import {Observable} from 'rxjs/Observable';
import {tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  numNewChatMessages = 0;

  constructor(private http: HttpClient) {

  }

  getConversations(userId: string): Observable<TdoChatConversationDataModel[]> {
    return this.http.get<TdoChatConversationDataModel[]>(`api/chat/get-conversations/${userId}`);
  }

  saveConversation(conversation: TdoChatConversationDataModel): Observable<TdoChatConversationDataModel> {
    return this.http.post<TdoChatConversationDataModel>('api/chat/save-conversation', conversation);
  }

  saveChatMessage(message: TdoChatDataModel): Observable<TdoChatDataModel> {
    return this.http.post<TdoChatDataModel>('api/chat/save-chat-message', message);
  }

  getNumUnreadMessages(userId: string): Observable<number> {
    return this.http.get<number>(`api/chat/get-num-unread-messages/${userId}`)
      .pipe(
        tap(_ => {
          this.numNewChatMessages = _;
        })
      );
  }

  updateChatMessageStatus(chatMessageIds: string[], status: string): Observable<void> {
    return this.http.post<void>(`api/chat/update-chat-message-status`, {chatMessageIds, status});
  }
}
